
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree7ff"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree7ff"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k2fvL", function(module, exports) {
// When the search input is focused, add a class to the header.
// This is used to hide some other elements and expand the search bar.
let $e96006cd3b433c6e$var$search = document.querySelector("#search-input");
let $e96006cd3b433c6e$var$header = document.querySelector("header");
$e96006cd3b433c6e$var$search.onfocus = ()=>{
    $e96006cd3b433c6e$var$header.classList.add("search");
};
$e96006cd3b433c6e$var$search.onblur = ()=>{
    $e96006cd3b433c6e$var$header.classList.remove("search");
};
docsearch({
    appId: "BG2BI65LT3",
    apiKey: "6309d86dabd1e4f3de34109753166903",
    indexName: "parceljs",
    inputSelector: "#search-input",
    algoliaOptions: {
        facetFilters: [
            "lang:en",
            "version:v2"
        ]
    }
});
if (typeof visualViewport !== "undefined") visualViewport.addEventListener("resize", ()=>{
    document.documentElement.style.setProperty("--viewport-height", visualViewport.height + "px");
});

});

// packages/alpinejs/src/scheduler.js
var $b4d83761af74a553$var$flushPending = false;
var $b4d83761af74a553$var$flushing = false;
var $b4d83761af74a553$var$queue = [];
function $b4d83761af74a553$var$scheduler(callback) {
    $b4d83761af74a553$var$queueJob(callback);
}
function $b4d83761af74a553$var$queueJob(job) {
    if (!$b4d83761af74a553$var$queue.includes(job)) $b4d83761af74a553$var$queue.push(job);
    $b4d83761af74a553$var$queueFlush();
}
function $b4d83761af74a553$var$dequeueJob(job) {
    let index = $b4d83761af74a553$var$queue.indexOf(job);
    if (index !== -1) $b4d83761af74a553$var$queue.splice(index, 1);
}
function $b4d83761af74a553$var$queueFlush() {
    if (!$b4d83761af74a553$var$flushing && !$b4d83761af74a553$var$flushPending) {
        $b4d83761af74a553$var$flushPending = true;
        queueMicrotask($b4d83761af74a553$var$flushJobs);
    }
}
function $b4d83761af74a553$var$flushJobs() {
    $b4d83761af74a553$var$flushPending = false;
    $b4d83761af74a553$var$flushing = true;
    for(let i = 0; i < $b4d83761af74a553$var$queue.length; i++)$b4d83761af74a553$var$queue[i]();
    $b4d83761af74a553$var$queue.length = 0;
    $b4d83761af74a553$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $b4d83761af74a553$var$reactive;
var $b4d83761af74a553$var$effect;
var $b4d83761af74a553$var$release;
var $b4d83761af74a553$var$raw;
var $b4d83761af74a553$var$shouldSchedule = true;
function $b4d83761af74a553$var$disableEffectScheduling(callback) {
    $b4d83761af74a553$var$shouldSchedule = false;
    callback();
    $b4d83761af74a553$var$shouldSchedule = true;
}
function $b4d83761af74a553$var$setReactivityEngine(engine) {
    $b4d83761af74a553$var$reactive = engine.reactive;
    $b4d83761af74a553$var$release = engine.release;
    $b4d83761af74a553$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($b4d83761af74a553$var$shouldSchedule) $b4d83761af74a553$var$scheduler(task);
                else task();
            }
        });
    $b4d83761af74a553$var$raw = engine.raw;
}
function $b4d83761af74a553$var$overrideEffect(override) {
    $b4d83761af74a553$var$effect = override;
}
function $b4d83761af74a553$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $b4d83761af74a553$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $b4d83761af74a553$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/mutation.js
var $b4d83761af74a553$var$onAttributeAddeds = [];
var $b4d83761af74a553$var$onElRemoveds = [];
var $b4d83761af74a553$var$onElAddeds = [];
function $b4d83761af74a553$var$onElAdded(callback) {
    $b4d83761af74a553$var$onElAddeds.push(callback);
}
function $b4d83761af74a553$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $b4d83761af74a553$var$onElRemoveds.push(callback);
    }
}
function $b4d83761af74a553$var$onAttributesAdded(callback) {
    $b4d83761af74a553$var$onAttributeAddeds.push(callback);
}
function $b4d83761af74a553$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $b4d83761af74a553$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
var $b4d83761af74a553$var$observer = new MutationObserver($b4d83761af74a553$var$onMutate);
var $b4d83761af74a553$var$currentlyObserving = false;
function $b4d83761af74a553$var$startObservingMutations() {
    $b4d83761af74a553$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $b4d83761af74a553$var$currentlyObserving = true;
}
function $b4d83761af74a553$var$stopObservingMutations() {
    $b4d83761af74a553$var$flushObserver();
    $b4d83761af74a553$var$observer.disconnect();
    $b4d83761af74a553$var$currentlyObserving = false;
}
var $b4d83761af74a553$var$recordQueue = [];
var $b4d83761af74a553$var$willProcessRecordQueue = false;
function $b4d83761af74a553$var$flushObserver() {
    $b4d83761af74a553$var$recordQueue = $b4d83761af74a553$var$recordQueue.concat($b4d83761af74a553$var$observer.takeRecords());
    if ($b4d83761af74a553$var$recordQueue.length && !$b4d83761af74a553$var$willProcessRecordQueue) {
        $b4d83761af74a553$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $b4d83761af74a553$var$processRecordQueue();
            $b4d83761af74a553$var$willProcessRecordQueue = false;
        });
    }
}
function $b4d83761af74a553$var$processRecordQueue() {
    $b4d83761af74a553$var$onMutate($b4d83761af74a553$var$recordQueue);
    $b4d83761af74a553$var$recordQueue.length = 0;
}
function $b4d83761af74a553$var$mutateDom(callback) {
    if (!$b4d83761af74a553$var$currentlyObserving) return callback();
    $b4d83761af74a553$var$stopObservingMutations();
    let result = callback();
    $b4d83761af74a553$var$startObservingMutations();
    return result;
}
var $b4d83761af74a553$var$isCollecting = false;
var $b4d83761af74a553$var$deferredMutations = [];
function $b4d83761af74a553$var$deferMutations() {
    $b4d83761af74a553$var$isCollecting = true;
}
function $b4d83761af74a553$var$flushAndStopDeferringMutations() {
    $b4d83761af74a553$var$isCollecting = false;
    $b4d83761af74a553$var$onMutate($b4d83761af74a553$var$deferredMutations);
    $b4d83761af74a553$var$deferredMutations = [];
}
function $b4d83761af74a553$var$onMutate(mutations) {
    if ($b4d83761af74a553$var$isCollecting) {
        $b4d83761af74a553$var$deferredMutations = $b4d83761af74a553$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = new Map();
    let removedAttributes = new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $b4d83761af74a553$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $b4d83761af74a553$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $b4d83761af74a553$var$onElRemoveds.forEach((i)=>i(node));
        if (node._x_cleanups) while(node._x_cleanups.length)node._x_cleanups.pop()();
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $b4d83761af74a553$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $b4d83761af74a553$var$scope(node) {
    return $b4d83761af74a553$var$mergeProxies($b4d83761af74a553$var$closestDataStack(node));
}
function $b4d83761af74a553$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$b4d83761af74a553$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $b4d83761af74a553$var$refreshScope(element, scope2) {
    let existingScope = element._x_dataStack[0];
    Object.entries(scope2).forEach(([key, value])=>{
        existingScope[key] = value;
    });
}
function $b4d83761af74a553$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $b4d83761af74a553$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $b4d83761af74a553$var$closestDataStack(node.parentNode);
}
function $b4d83761af74a553$var$mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
        ownKeys: ()=>{
            return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
        },
        has: (target, name)=>{
            return objects.some((obj)=>obj.hasOwnProperty(name));
        },
        get: (target, name)=>{
            return (objects.find((obj)=>{
                if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) return true;
                    if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
                        let getter = descriptor.get;
                        let setter = descriptor.set;
                        let property = descriptor;
                        getter = getter && getter.bind(thisProxy);
                        setter = setter && setter.bind(thisProxy);
                        if (getter) getter._x_alreadyBound = true;
                        if (setter) setter._x_alreadyBound = true;
                        Object.defineProperty(obj, name, {
                            ...property,
                            get: getter,
                            set: setter
                        });
                    }
                    return true;
                }
                return false;
            }) || {})[name];
        },
        set: (target, name, value)=>{
            let closestObjectWithKey = objects.find((obj)=>obj.hasOwnProperty(name));
            if (closestObjectWithKey) closestObjectWithKey[name] = value;
            else objects[objects.length - 1][name] = value;
            return true;
        }
    });
    return thisProxy;
}
// packages/alpinejs/src/interceptor.js
function $b4d83761af74a553$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $b4d83761af74a553$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$b4d83761af74a553$var$get(data2, path), (value)=>$b4d83761af74a553$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $b4d83761af74a553$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $b4d83761af74a553$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $b4d83761af74a553$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $b4d83761af74a553$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $b4d83761af74a553$var$magics = {};
function $b4d83761af74a553$var$magic(name, callback) {
    $b4d83761af74a553$var$magics[name] = callback;
}
function $b4d83761af74a553$var$injectMagics(obj, el) {
    Object.entries($b4d83761af74a553$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                let [utilities, cleanup2] = $b4d83761af74a553$var$getElementBoundUtilities(el);
                utilities = {
                    interceptor: $b4d83761af74a553$var$interceptor,
                    ...utilities
                };
                $b4d83761af74a553$var$onElRemoved(el, cleanup2);
                return callback(el, utilities);
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $b4d83761af74a553$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $b4d83761af74a553$var$handleError(e, el, expression);
    }
}
function $b4d83761af74a553$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $b4d83761af74a553$var$shouldAutoEvaluateFunctions = true;
function $b4d83761af74a553$var$dontAutoEvaluateFunctions(callback) {
    let cache = $b4d83761af74a553$var$shouldAutoEvaluateFunctions;
    $b4d83761af74a553$var$shouldAutoEvaluateFunctions = false;
    callback();
    $b4d83761af74a553$var$shouldAutoEvaluateFunctions = cache;
}
function $b4d83761af74a553$var$evaluate(el, expression, extras = {}) {
    let result;
    $b4d83761af74a553$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $b4d83761af74a553$var$evaluateLater(...args) {
    return $b4d83761af74a553$var$theEvaluatorFunction(...args);
}
var $b4d83761af74a553$var$theEvaluatorFunction = $b4d83761af74a553$var$normalEvaluator;
function $b4d83761af74a553$var$setEvaluator(newEvaluator) {
    $b4d83761af74a553$var$theEvaluatorFunction = newEvaluator;
}
function $b4d83761af74a553$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $b4d83761af74a553$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$b4d83761af74a553$var$closestDataStack(el)
    ];
    if (typeof expression === "function") return $b4d83761af74a553$var$generateEvaluatorFromFunction(dataStack, expression);
    let evaluator = $b4d83761af74a553$var$generateEvaluatorFromString(dataStack, expression, el);
    return $b4d83761af74a553$var$tryCatch.bind(null, el, expression, evaluator);
}
function $b4d83761af74a553$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($b4d83761af74a553$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $b4d83761af74a553$var$runIfTypeOfFunction(receiver, result);
    };
}
var $b4d83761af74a553$var$evaluatorMemo = {};
function $b4d83761af74a553$var$generateFunctionFromString(expression, el) {
    if ($b4d83761af74a553$var$evaluatorMemo[expression]) return $b4d83761af74a553$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(() => { ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            return new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
        } catch (error2) {
            $b4d83761af74a553$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $b4d83761af74a553$var$evaluatorMemo[expression] = func;
    return func;
}
function $b4d83761af74a553$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $b4d83761af74a553$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $b4d83761af74a553$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$b4d83761af74a553$var$handleError(error2, el, expression));
            if (func.finished) {
                $b4d83761af74a553$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $b4d83761af74a553$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$b4d83761af74a553$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $b4d83761af74a553$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($b4d83761af74a553$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$b4d83761af74a553$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$b4d83761af74a553$var$handleError(error2, el, value));
        else receiver(result);
    } else receiver(value);
}
// packages/alpinejs/src/directives.js
var $b4d83761af74a553$var$prefixAsString = "x-";
function $b4d83761af74a553$var$prefix(subject = "") {
    return $b4d83761af74a553$var$prefixAsString + subject;
}
function $b4d83761af74a553$var$setPrefix(newPrefix) {
    $b4d83761af74a553$var$prefixAsString = newPrefix;
}
var $b4d83761af74a553$var$directiveHandlers = {};
function $b4d83761af74a553$var$directive(name, callback) {
    $b4d83761af74a553$var$directiveHandlers[name] = callback;
}
function $b4d83761af74a553$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $b4d83761af74a553$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($b4d83761af74a553$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($b4d83761af74a553$var$outNonAlpineAttributes).map($b4d83761af74a553$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($b4d83761af74a553$var$byPriority);
    return directives2.map((directive2)=>{
        return $b4d83761af74a553$var$getDirectiveHandler(el, directive2);
    });
}
function $b4d83761af74a553$var$attributesOnly(attributes) {
    return Array.from(attributes).map($b4d83761af74a553$var$toTransformedAttributes()).filter((attr)=>!$b4d83761af74a553$var$outNonAlpineAttributes(attr));
}
var $b4d83761af74a553$var$isDeferringHandlers = false;
var $b4d83761af74a553$var$directiveHandlerStacks = new Map();
var $b4d83761af74a553$var$currentHandlerStackKey = Symbol();
function $b4d83761af74a553$var$deferHandlingDirectives(callback) {
    $b4d83761af74a553$var$isDeferringHandlers = true;
    let key = Symbol();
    $b4d83761af74a553$var$currentHandlerStackKey = key;
    $b4d83761af74a553$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($b4d83761af74a553$var$directiveHandlerStacks.get(key).length)$b4d83761af74a553$var$directiveHandlerStacks.get(key).shift()();
        $b4d83761af74a553$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $b4d83761af74a553$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $b4d83761af74a553$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $b4d83761af74a553$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $b4d83761af74a553$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $b4d83761af74a553$var$evaluateLater.bind($b4d83761af74a553$var$evaluateLater, el),
        evaluate: $b4d83761af74a553$var$evaluate.bind($b4d83761af74a553$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $b4d83761af74a553$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler3 = $b4d83761af74a553$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $b4d83761af74a553$var$getElementBoundUtilities(el);
    $b4d83761af74a553$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler3.inline && handler3.inline(el, directive2, utilities);
        handler3 = handler3.bind(handler3, el, directive2, utilities);
        $b4d83761af74a553$var$isDeferringHandlers ? $b4d83761af74a553$var$directiveHandlerStacks.get($b4d83761af74a553$var$currentHandlerStackKey).push(handler3) : handler3();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $b4d83761af74a553$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $b4d83761af74a553$var$into = (i)=>i;
function $b4d83761af74a553$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $b4d83761af74a553$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $b4d83761af74a553$var$attributeTransformers = [];
function $b4d83761af74a553$var$mapAttributes(callback) {
    $b4d83761af74a553$var$attributeTransformers.push(callback);
}
function $b4d83761af74a553$var$outNonAlpineAttributes({ name: name }) {
    return $b4d83761af74a553$var$alpineAttributeRegex().test(name);
}
var $b4d83761af74a553$var$alpineAttributeRegex = ()=>new RegExp(`^${$b4d83761af74a553$var$prefixAsString}([^:^.]+)\\b`);
function $b4d83761af74a553$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($b4d83761af74a553$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $b4d83761af74a553$var$DEFAULT = "DEFAULT";
var $b4d83761af74a553$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "radio",
    "tabs",
    "switch",
    "disclosure",
    "menu",
    "listbox",
    "list",
    "item",
    "combobox",
    "bind",
    "init",
    "for",
    "mask",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $b4d83761af74a553$var$DEFAULT,
    "teleport"
];
function $b4d83761af74a553$var$byPriority(a, b) {
    let typeA = $b4d83761af74a553$var$directiveOrder.indexOf(a.type) === -1 ? $b4d83761af74a553$var$DEFAULT : a.type;
    let typeB = $b4d83761af74a553$var$directiveOrder.indexOf(b.type) === -1 ? $b4d83761af74a553$var$DEFAULT : b.type;
    return $b4d83761af74a553$var$directiveOrder.indexOf(typeA) - $b4d83761af74a553$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $b4d83761af74a553$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/nextTick.js
var $b4d83761af74a553$var$tickStack = [];
var $b4d83761af74a553$var$isHolding = false;
function $b4d83761af74a553$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $b4d83761af74a553$var$isHolding || setTimeout(()=>{
            $b4d83761af74a553$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $b4d83761af74a553$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $b4d83761af74a553$var$releaseNextTicks() {
    $b4d83761af74a553$var$isHolding = false;
    while($b4d83761af74a553$var$tickStack.length)$b4d83761af74a553$var$tickStack.shift()();
}
function $b4d83761af74a553$var$holdNextTicks() {
    $b4d83761af74a553$var$isHolding = true;
}
// packages/alpinejs/src/utils/walk.js
function $b4d83761af74a553$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$b4d83761af74a553$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $b4d83761af74a553$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $b4d83761af74a553$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
function $b4d83761af74a553$var$start() {
    if (!document.body) $b4d83761af74a553$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $b4d83761af74a553$var$dispatch(document, "alpine:init");
    $b4d83761af74a553$var$dispatch(document, "alpine:initializing");
    $b4d83761af74a553$var$startObservingMutations();
    $b4d83761af74a553$var$onElAdded((el)=>$b4d83761af74a553$var$initTree(el, $b4d83761af74a553$var$walk));
    $b4d83761af74a553$var$onElRemoved((el)=>$b4d83761af74a553$var$destroyTree(el));
    $b4d83761af74a553$var$onAttributesAdded((el, attrs)=>{
        $b4d83761af74a553$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$b4d83761af74a553$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($b4d83761af74a553$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $b4d83761af74a553$var$initTree(el);
    });
    $b4d83761af74a553$var$dispatch(document, "alpine:initialized");
}
var $b4d83761af74a553$var$rootSelectorCallbacks = [];
var $b4d83761af74a553$var$initSelectorCallbacks = [];
function $b4d83761af74a553$var$rootSelectors() {
    return $b4d83761af74a553$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $b4d83761af74a553$var$allSelectors() {
    return $b4d83761af74a553$var$rootSelectorCallbacks.concat($b4d83761af74a553$var$initSelectorCallbacks).map((fn)=>fn());
}
function $b4d83761af74a553$var$addRootSelector(selectorCallback) {
    $b4d83761af74a553$var$rootSelectorCallbacks.push(selectorCallback);
}
function $b4d83761af74a553$var$addInitSelector(selectorCallback) {
    $b4d83761af74a553$var$initSelectorCallbacks.push(selectorCallback);
}
function $b4d83761af74a553$var$closestRoot(el, includeInitSelectors = false) {
    return $b4d83761af74a553$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $b4d83761af74a553$var$allSelectors() : $b4d83761af74a553$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $b4d83761af74a553$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $b4d83761af74a553$var$findClosest(el.parentElement, callback);
}
function $b4d83761af74a553$var$isRoot(el) {
    return $b4d83761af74a553$var$rootSelectors().some((selector)=>el.matches(selector));
}
function $b4d83761af74a553$var$initTree(el, walker = $b4d83761af74a553$var$walk) {
    $b4d83761af74a553$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            $b4d83761af74a553$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $b4d83761af74a553$var$destroyTree(root) {
    $b4d83761af74a553$var$walk(root, (el)=>$b4d83761af74a553$var$cleanupAttributes(el));
}
// packages/alpinejs/src/utils/classes.js
function $b4d83761af74a553$var$setClasses(el, value) {
    if (Array.isArray(value)) return $b4d83761af74a553$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $b4d83761af74a553$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $b4d83761af74a553$var$setClasses(el, value());
    return $b4d83761af74a553$var$setClassesFromString(el, value);
}
function $b4d83761af74a553$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $b4d83761af74a553$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $b4d83761af74a553$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $b4d83761af74a553$var$setStylesFromObject(el, value);
    return $b4d83761af74a553$var$setStylesFromString(el, value);
}
function $b4d83761af74a553$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $b4d83761af74a553$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $b4d83761af74a553$var$setStyles(el, previousStyles);
    };
}
function $b4d83761af74a553$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $b4d83761af74a553$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $b4d83761af74a553$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$b4d83761af74a553$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (!expression) $b4d83761af74a553$var$registerTransitionsFromHelper(el, modifiers, value);
    else $b4d83761af74a553$var$registerTransitionsFromClassString(el, expression, value);
});
function $b4d83761af74a553$var$registerTransitionsFromClassString(el, classString, stage) {
    $b4d83761af74a553$var$registerTransitionObject(el, $b4d83761af74a553$var$setClasses, "");
    let directiveStorageMap = {
        enter: (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        leave: (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $b4d83761af74a553$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $b4d83761af74a553$var$registerTransitionObject(el, $b4d83761af74a553$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $b4d83761af74a553$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $b4d83761af74a553$var$modifierValue(modifiers, "delay", 0);
    let origin = $b4d83761af74a553$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $b4d83761af74a553$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $b4d83761af74a553$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: delay,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: delay,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $b4d83761af74a553$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $b4d83761af74a553$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $b4d83761af74a553$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $b4d83761af74a553$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $b4d83761af74a553$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $b4d83761af74a553$var$closestHide(parent);
}
function $b4d83761af74a553$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $b4d83761af74a553$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $b4d83761af74a553$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $b4d83761af74a553$var$once(()=>{
        $b4d83761af74a553$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $b4d83761af74a553$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $b4d83761af74a553$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $b4d83761af74a553$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $b4d83761af74a553$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $b4d83761af74a553$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $b4d83761af74a553$var$mutateDom(()=>{
                stages.end();
            });
            $b4d83761af74a553$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $b4d83761af74a553$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $b4d83761af74a553$var$isCloning = false;
function $b4d83761af74a553$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$b4d83761af74a553$var$isCloning ? fallback(...args) : callback(...args);
}
function $b4d83761af74a553$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $b4d83761af74a553$var$isCloning = true;
    $b4d83761af74a553$var$dontRegisterReactiveSideEffects(()=>{
        $b4d83761af74a553$var$cloneTree(newEl);
    });
    $b4d83761af74a553$var$isCloning = false;
}
function $b4d83761af74a553$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $b4d83761af74a553$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $b4d83761af74a553$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $b4d83761af74a553$var$initTree(el, shallowWalker);
}
function $b4d83761af74a553$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $b4d83761af74a553$var$effect;
    $b4d83761af74a553$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $b4d83761af74a553$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $b4d83761af74a553$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $b4d83761af74a553$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $b4d83761af74a553$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $b4d83761af74a553$var$camelCase(name) : name;
    switch(name){
        case "value":
            $b4d83761af74a553$var$bindInputValue(el, value);
            break;
        case "style":
            $b4d83761af74a553$var$bindStyles(el, value);
            break;
        case "class":
            $b4d83761af74a553$var$bindClasses(el, value);
            break;
        default:
            $b4d83761af74a553$var$bindAttribute(el, name, value);
            break;
    }
}
function $b4d83761af74a553$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $b4d83761af74a553$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$b4d83761af74a553$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $b4d83761af74a553$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value;
    }
}
function $b4d83761af74a553$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $b4d83761af74a553$var$setClasses(el, value);
}
function $b4d83761af74a553$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $b4d83761af74a553$var$setStyles(el, value);
}
function $b4d83761af74a553$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $b4d83761af74a553$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($b4d83761af74a553$var$isBooleanAttr(name)) value = name;
        $b4d83761af74a553$var$setIfChanged(el, name, value);
    }
}
function $b4d83761af74a553$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $b4d83761af74a553$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $b4d83761af74a553$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b4d83761af74a553$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $b4d83761af74a553$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $b4d83761af74a553$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $b4d83761af74a553$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($b4d83761af74a553$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $b4d83761af74a553$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $b4d83761af74a553$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/plugin.js
function $b4d83761af74a553$var$plugin(callback) {
    callback($b4d83761af74a553$var$alpine_default);
}
// packages/alpinejs/src/store.js
var $b4d83761af74a553$var$stores = {};
var $b4d83761af74a553$var$isReactive = false;
function $b4d83761af74a553$var$store(name, value) {
    if (!$b4d83761af74a553$var$isReactive) {
        $b4d83761af74a553$var$stores = $b4d83761af74a553$var$reactive($b4d83761af74a553$var$stores);
        $b4d83761af74a553$var$isReactive = true;
    }
    if (value === void 0) return $b4d83761af74a553$var$stores[name];
    $b4d83761af74a553$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $b4d83761af74a553$var$stores[name].init();
    $b4d83761af74a553$var$initInterceptors($b4d83761af74a553$var$stores[name]);
}
function $b4d83761af74a553$var$getStores() {
    return $b4d83761af74a553$var$stores;
}
// packages/alpinejs/src/binds.js
var $b4d83761af74a553$var$binds = {};
function $b4d83761af74a553$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) $b4d83761af74a553$var$applyBindingsObject(name, getBindings());
    else $b4d83761af74a553$var$binds[name] = getBindings;
}
function $b4d83761af74a553$var$injectBindingProviders(obj) {
    Object.entries($b4d83761af74a553$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $b4d83761af74a553$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $b4d83761af74a553$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $b4d83761af74a553$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
}
// packages/alpinejs/src/datas.js
var $b4d83761af74a553$var$datas = {};
function $b4d83761af74a553$var$data(name, callback) {
    $b4d83761af74a553$var$datas[name] = callback;
}
function $b4d83761af74a553$var$injectDataProviders(obj, context) {
    Object.entries($b4d83761af74a553$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $b4d83761af74a553$var$Alpine = {
    get reactive () {
        return $b4d83761af74a553$var$reactive;
    },
    get release () {
        return $b4d83761af74a553$var$release;
    },
    get effect () {
        return $b4d83761af74a553$var$effect;
    },
    get raw () {
        return $b4d83761af74a553$var$raw;
    },
    version: "3.10.5",
    flushAndStopDeferringMutations: $b4d83761af74a553$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $b4d83761af74a553$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $b4d83761af74a553$var$disableEffectScheduling,
    setReactivityEngine: $b4d83761af74a553$var$setReactivityEngine,
    closestDataStack: $b4d83761af74a553$var$closestDataStack,
    skipDuringClone: $b4d83761af74a553$var$skipDuringClone,
    addRootSelector: $b4d83761af74a553$var$addRootSelector,
    addInitSelector: $b4d83761af74a553$var$addInitSelector,
    addScopeToNode: $b4d83761af74a553$var$addScopeToNode,
    deferMutations: $b4d83761af74a553$var$deferMutations,
    mapAttributes: $b4d83761af74a553$var$mapAttributes,
    evaluateLater: $b4d83761af74a553$var$evaluateLater,
    setEvaluator: $b4d83761af74a553$var$setEvaluator,
    mergeProxies: $b4d83761af74a553$var$mergeProxies,
    findClosest: $b4d83761af74a553$var$findClosest,
    closestRoot: $b4d83761af74a553$var$closestRoot,
    interceptor: $b4d83761af74a553$var$interceptor,
    transition: $b4d83761af74a553$var$transition,
    setStyles: $b4d83761af74a553$var$setStyles,
    mutateDom: $b4d83761af74a553$var$mutateDom,
    directive: $b4d83761af74a553$var$directive,
    throttle: $b4d83761af74a553$var$throttle,
    debounce: $b4d83761af74a553$var$debounce,
    evaluate: $b4d83761af74a553$var$evaluate,
    initTree: $b4d83761af74a553$var$initTree,
    nextTick: $b4d83761af74a553$var$nextTick,
    prefixed: $b4d83761af74a553$var$prefix,
    prefix: $b4d83761af74a553$var$setPrefix,
    plugin: $b4d83761af74a553$var$plugin,
    magic: $b4d83761af74a553$var$magic,
    store: $b4d83761af74a553$var$store,
    start: $b4d83761af74a553$var$start,
    clone: $b4d83761af74a553$var$clone,
    bound: $b4d83761af74a553$var$getBinding,
    $data: $b4d83761af74a553$var$scope,
    data: $b4d83761af74a553$var$data,
    bind: $b4d83761af74a553$var$bind2
};
var $b4d83761af74a553$var$alpine_default = $b4d83761af74a553$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $b4d83761af74a553$var$makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $b4d83761af74a553$var$PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
var $b4d83761af74a553$var$slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
var $b4d83761af74a553$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $b4d83761af74a553$var$isBooleanAttr2 = /* @__PURE__ */ $b4d83761af74a553$var$makeMap($b4d83761af74a553$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $b4d83761af74a553$var$EMPTY_OBJ = Object.freeze({});
var $b4d83761af74a553$var$EMPTY_ARR = Object.freeze([]);
var $b4d83761af74a553$var$extend = Object.assign;
var $b4d83761af74a553$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b4d83761af74a553$var$hasOwn = (val, key)=>$b4d83761af74a553$var$hasOwnProperty.call(val, key);
var $b4d83761af74a553$var$isArray = Array.isArray;
var $b4d83761af74a553$var$isMap = (val)=>$b4d83761af74a553$var$toTypeString(val) === "[object Map]";
var $b4d83761af74a553$var$isString = (val)=>typeof val === "string";
var $b4d83761af74a553$var$isSymbol = (val)=>typeof val === "symbol";
var $b4d83761af74a553$var$isObject = (val)=>val !== null && typeof val === "object";
var $b4d83761af74a553$var$objectToString = Object.prototype.toString;
var $b4d83761af74a553$var$toTypeString = (value)=>$b4d83761af74a553$var$objectToString.call(value);
var $b4d83761af74a553$var$toRawType = (value)=>{
    return $b4d83761af74a553$var$toTypeString(value).slice(8, -1);
};
var $b4d83761af74a553$var$isIntegerKey = (key)=>$b4d83761af74a553$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $b4d83761af74a553$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $b4d83761af74a553$var$camelizeRE = /-(\w)/g;
var $b4d83761af74a553$var$camelize = $b4d83761af74a553$var$cacheStringFunction((str)=>{
    return str.replace($b4d83761af74a553$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $b4d83761af74a553$var$hyphenateRE = /\B([A-Z])/g;
var $b4d83761af74a553$var$hyphenate = $b4d83761af74a553$var$cacheStringFunction((str)=>str.replace($b4d83761af74a553$var$hyphenateRE, "-$1").toLowerCase());
var $b4d83761af74a553$var$capitalize = $b4d83761af74a553$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $b4d83761af74a553$var$toHandlerKey = $b4d83761af74a553$var$cacheStringFunction((str)=>str ? `on${$b4d83761af74a553$var$capitalize(str)}` : ``);
var $b4d83761af74a553$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $b4d83761af74a553$var$targetMap = new WeakMap();
var $b4d83761af74a553$var$effectStack = [];
var $b4d83761af74a553$var$activeEffect;
var $b4d83761af74a553$var$ITERATE_KEY = Symbol("iterate");
var $b4d83761af74a553$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $b4d83761af74a553$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $b4d83761af74a553$var$effect2(fn, options = $b4d83761af74a553$var$EMPTY_OBJ) {
    if ($b4d83761af74a553$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $b4d83761af74a553$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $b4d83761af74a553$var$stop(effect3) {
    if (effect3.active) {
        $b4d83761af74a553$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $b4d83761af74a553$var$uid = 0;
function $b4d83761af74a553$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$b4d83761af74a553$var$effectStack.includes(effect3)) {
            $b4d83761af74a553$var$cleanup(effect3);
            try {
                $b4d83761af74a553$var$enableTracking();
                $b4d83761af74a553$var$effectStack.push(effect3);
                $b4d83761af74a553$var$activeEffect = effect3;
                return fn();
            } finally{
                $b4d83761af74a553$var$effectStack.pop();
                $b4d83761af74a553$var$resetTracking();
                $b4d83761af74a553$var$activeEffect = $b4d83761af74a553$var$effectStack[$b4d83761af74a553$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $b4d83761af74a553$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $b4d83761af74a553$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $b4d83761af74a553$var$shouldTrack = true;
var $b4d83761af74a553$var$trackStack = [];
function $b4d83761af74a553$var$pauseTracking() {
    $b4d83761af74a553$var$trackStack.push($b4d83761af74a553$var$shouldTrack);
    $b4d83761af74a553$var$shouldTrack = false;
}
function $b4d83761af74a553$var$enableTracking() {
    $b4d83761af74a553$var$trackStack.push($b4d83761af74a553$var$shouldTrack);
    $b4d83761af74a553$var$shouldTrack = true;
}
function $b4d83761af74a553$var$resetTracking() {
    const last = $b4d83761af74a553$var$trackStack.pop();
    $b4d83761af74a553$var$shouldTrack = last === void 0 ? true : last;
}
function $b4d83761af74a553$var$track(target, type, key) {
    if (!$b4d83761af74a553$var$shouldTrack || $b4d83761af74a553$var$activeEffect === void 0) return;
    let depsMap = $b4d83761af74a553$var$targetMap.get(target);
    if (!depsMap) $b4d83761af74a553$var$targetMap.set(target, depsMap = new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = new Set());
    if (!dep.has($b4d83761af74a553$var$activeEffect)) {
        dep.add($b4d83761af74a553$var$activeEffect);
        $b4d83761af74a553$var$activeEffect.deps.push(dep);
        if ($b4d83761af74a553$var$activeEffect.options.onTrack) $b4d83761af74a553$var$activeEffect.options.onTrack({
            effect: $b4d83761af74a553$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $b4d83761af74a553$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $b4d83761af74a553$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $b4d83761af74a553$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $b4d83761af74a553$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$b4d83761af74a553$var$isArray(target)) {
                    add2(depsMap.get($b4d83761af74a553$var$ITERATE_KEY));
                    if ($b4d83761af74a553$var$isMap(target)) add2(depsMap.get($b4d83761af74a553$var$MAP_KEY_ITERATE_KEY));
                } else if ($b4d83761af74a553$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$b4d83761af74a553$var$isArray(target)) {
                    add2(depsMap.get($b4d83761af74a553$var$ITERATE_KEY));
                    if ($b4d83761af74a553$var$isMap(target)) add2(depsMap.get($b4d83761af74a553$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($b4d83761af74a553$var$isMap(target)) add2(depsMap.get($b4d83761af74a553$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $b4d83761af74a553$var$isNonTrackableKeys = /* @__PURE__ */ $b4d83761af74a553$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $b4d83761af74a553$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($b4d83761af74a553$var$isSymbol));
var $b4d83761af74a553$var$get2 = /* @__PURE__ */ $b4d83761af74a553$var$createGetter();
var $b4d83761af74a553$var$shallowGet = /* @__PURE__ */ $b4d83761af74a553$var$createGetter(false, true);
var $b4d83761af74a553$var$readonlyGet = /* @__PURE__ */ $b4d83761af74a553$var$createGetter(true);
var $b4d83761af74a553$var$shallowReadonlyGet = /* @__PURE__ */ $b4d83761af74a553$var$createGetter(true, true);
var $b4d83761af74a553$var$arrayInstrumentations = {};
[
    "includes",
    "indexOf",
    "lastIndexOf"
].forEach((key)=>{
    const method = Array.prototype[key];
    $b4d83761af74a553$var$arrayInstrumentations[key] = function(...args) {
        const arr = $b4d83761af74a553$var$toRaw(this);
        for(let i = 0, l = this.length; i < l; i++)$b4d83761af74a553$var$track(arr, "get", i + "");
        const res = method.apply(arr, args);
        if (res === -1 || res === false) return method.apply(arr, args.map($b4d83761af74a553$var$toRaw));
        else return res;
    };
});
[
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
].forEach((key)=>{
    const method = Array.prototype[key];
    $b4d83761af74a553$var$arrayInstrumentations[key] = function(...args) {
        $b4d83761af74a553$var$pauseTracking();
        const res = method.apply(this, args);
        $b4d83761af74a553$var$resetTracking();
        return res;
    };
});
function $b4d83761af74a553$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $b4d83761af74a553$var$shallowReadonlyMap : $b4d83761af74a553$var$readonlyMap : shallow ? $b4d83761af74a553$var$shallowReactiveMap : $b4d83761af74a553$var$reactiveMap).get(target)) return target;
        const targetIsArray = $b4d83761af74a553$var$isArray(target);
        if (!isReadonly && targetIsArray && $b4d83761af74a553$var$hasOwn($b4d83761af74a553$var$arrayInstrumentations, key)) return Reflect.get($b4d83761af74a553$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($b4d83761af74a553$var$isSymbol(key) ? $b4d83761af74a553$var$builtInSymbols.has(key) : $b4d83761af74a553$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $b4d83761af74a553$var$track(target, "get", key);
        if (shallow) return res;
        if ($b4d83761af74a553$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$b4d83761af74a553$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($b4d83761af74a553$var$isObject(res)) return isReadonly ? $b4d83761af74a553$var$readonly(res) : $b4d83761af74a553$var$reactive2(res);
        return res;
    };
}
var $b4d83761af74a553$var$set2 = /* @__PURE__ */ $b4d83761af74a553$var$createSetter();
var $b4d83761af74a553$var$shallowSet = /* @__PURE__ */ $b4d83761af74a553$var$createSetter(true);
function $b4d83761af74a553$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $b4d83761af74a553$var$toRaw(value);
            oldValue = $b4d83761af74a553$var$toRaw(oldValue);
            if (!$b4d83761af74a553$var$isArray(target) && $b4d83761af74a553$var$isRef(oldValue) && !$b4d83761af74a553$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $b4d83761af74a553$var$isArray(target) && $b4d83761af74a553$var$isIntegerKey(key) ? Number(key) < target.length : $b4d83761af74a553$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $b4d83761af74a553$var$toRaw(receiver)) {
            if (!hadKey) $b4d83761af74a553$var$trigger(target, "add", key, value);
            else if ($b4d83761af74a553$var$hasChanged(value, oldValue)) $b4d83761af74a553$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $b4d83761af74a553$var$deleteProperty(target, key) {
    const hadKey = $b4d83761af74a553$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $b4d83761af74a553$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $b4d83761af74a553$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$b4d83761af74a553$var$isSymbol(key) || !$b4d83761af74a553$var$builtInSymbols.has(key)) $b4d83761af74a553$var$track(target, "has", key);
    return result;
}
function $b4d83761af74a553$var$ownKeys(target) {
    $b4d83761af74a553$var$track(target, "iterate", $b4d83761af74a553$var$isArray(target) ? "length" : $b4d83761af74a553$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $b4d83761af74a553$var$mutableHandlers = {
    get: $b4d83761af74a553$var$get2,
    set: $b4d83761af74a553$var$set2,
    deleteProperty: $b4d83761af74a553$var$deleteProperty,
    has: $b4d83761af74a553$var$has,
    ownKeys: $b4d83761af74a553$var$ownKeys
};
var $b4d83761af74a553$var$readonlyHandlers = {
    get: $b4d83761af74a553$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $b4d83761af74a553$var$shallowReactiveHandlers = $b4d83761af74a553$var$extend({}, $b4d83761af74a553$var$mutableHandlers, {
    get: $b4d83761af74a553$var$shallowGet,
    set: $b4d83761af74a553$var$shallowSet
});
var $b4d83761af74a553$var$shallowReadonlyHandlers = $b4d83761af74a553$var$extend({}, $b4d83761af74a553$var$readonlyHandlers, {
    get: $b4d83761af74a553$var$shallowReadonlyGet
});
var $b4d83761af74a553$var$toReactive = (value)=>$b4d83761af74a553$var$isObject(value) ? $b4d83761af74a553$var$reactive2(value) : value;
var $b4d83761af74a553$var$toReadonly = (value)=>$b4d83761af74a553$var$isObject(value) ? $b4d83761af74a553$var$readonly(value) : value;
var $b4d83761af74a553$var$toShallow = (value)=>value;
var $b4d83761af74a553$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $b4d83761af74a553$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $b4d83761af74a553$var$toRaw(target);
    const rawKey = $b4d83761af74a553$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $b4d83761af74a553$var$track(rawTarget, "get", key);
    !isReadonly && $b4d83761af74a553$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $b4d83761af74a553$var$getProto(rawTarget);
    const wrap = isShallow ? $b4d83761af74a553$var$toShallow : isReadonly ? $b4d83761af74a553$var$toReadonly : $b4d83761af74a553$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $b4d83761af74a553$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $b4d83761af74a553$var$toRaw(target);
    const rawKey = $b4d83761af74a553$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $b4d83761af74a553$var$track(rawTarget, "has", key);
    !isReadonly && $b4d83761af74a553$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $b4d83761af74a553$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $b4d83761af74a553$var$track($b4d83761af74a553$var$toRaw(target), "iterate", $b4d83761af74a553$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $b4d83761af74a553$var$add(value) {
    value = $b4d83761af74a553$var$toRaw(value);
    const target = $b4d83761af74a553$var$toRaw(this);
    const proto = $b4d83761af74a553$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $b4d83761af74a553$var$trigger(target, "add", value, value);
    }
    return this;
}
function $b4d83761af74a553$var$set$1(key, value) {
    value = $b4d83761af74a553$var$toRaw(value);
    const target = $b4d83761af74a553$var$toRaw(this);
    const { has: has2, get: get3 } = $b4d83761af74a553$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $b4d83761af74a553$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $b4d83761af74a553$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $b4d83761af74a553$var$trigger(target, "add", key, value);
    else if ($b4d83761af74a553$var$hasChanged(value, oldValue)) $b4d83761af74a553$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $b4d83761af74a553$var$deleteEntry(key) {
    const target = $b4d83761af74a553$var$toRaw(this);
    const { has: has2, get: get3 } = $b4d83761af74a553$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $b4d83761af74a553$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $b4d83761af74a553$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $b4d83761af74a553$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $b4d83761af74a553$var$clear() {
    const target = $b4d83761af74a553$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $b4d83761af74a553$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $b4d83761af74a553$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $b4d83761af74a553$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $b4d83761af74a553$var$toRaw(target);
        const wrap = isShallow ? $b4d83761af74a553$var$toShallow : isReadonly ? $b4d83761af74a553$var$toReadonly : $b4d83761af74a553$var$toReactive;
        !isReadonly && $b4d83761af74a553$var$track(rawTarget, "iterate", $b4d83761af74a553$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $b4d83761af74a553$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $b4d83761af74a553$var$toRaw(target);
        const targetIsMap = $b4d83761af74a553$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $b4d83761af74a553$var$toShallow : isReadonly ? $b4d83761af74a553$var$toReadonly : $b4d83761af74a553$var$toReactive;
        !isReadonly && $b4d83761af74a553$var$track(rawTarget, "iterate", isKeyOnly ? $b4d83761af74a553$var$MAP_KEY_ITERATE_KEY : $b4d83761af74a553$var$ITERATE_KEY);
        return {
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $b4d83761af74a553$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$b4d83761af74a553$var$capitalize(type)} operation ${key}failed: target is readonly.`, $b4d83761af74a553$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
var $b4d83761af74a553$var$mutableInstrumentations = {
    get (key) {
        return $b4d83761af74a553$var$get$1(this, key);
    },
    get size () {
        return $b4d83761af74a553$var$size(this);
    },
    has: $b4d83761af74a553$var$has$1,
    add: $b4d83761af74a553$var$add,
    set: $b4d83761af74a553$var$set$1,
    delete: $b4d83761af74a553$var$deleteEntry,
    clear: $b4d83761af74a553$var$clear,
    forEach: $b4d83761af74a553$var$createForEach(false, false)
};
var $b4d83761af74a553$var$shallowInstrumentations = {
    get (key) {
        return $b4d83761af74a553$var$get$1(this, key, false, true);
    },
    get size () {
        return $b4d83761af74a553$var$size(this);
    },
    has: $b4d83761af74a553$var$has$1,
    add: $b4d83761af74a553$var$add,
    set: $b4d83761af74a553$var$set$1,
    delete: $b4d83761af74a553$var$deleteEntry,
    clear: $b4d83761af74a553$var$clear,
    forEach: $b4d83761af74a553$var$createForEach(false, true)
};
var $b4d83761af74a553$var$readonlyInstrumentations = {
    get (key) {
        return $b4d83761af74a553$var$get$1(this, key, true);
    },
    get size () {
        return $b4d83761af74a553$var$size(this, true);
    },
    has (key) {
        return $b4d83761af74a553$var$has$1.call(this, key, true);
    },
    add: $b4d83761af74a553$var$createReadonlyMethod("add"),
    set: $b4d83761af74a553$var$createReadonlyMethod("set"),
    delete: $b4d83761af74a553$var$createReadonlyMethod("delete"),
    clear: $b4d83761af74a553$var$createReadonlyMethod("clear"),
    forEach: $b4d83761af74a553$var$createForEach(true, false)
};
var $b4d83761af74a553$var$shallowReadonlyInstrumentations = {
    get (key) {
        return $b4d83761af74a553$var$get$1(this, key, true, true);
    },
    get size () {
        return $b4d83761af74a553$var$size(this, true);
    },
    has (key) {
        return $b4d83761af74a553$var$has$1.call(this, key, true);
    },
    add: $b4d83761af74a553$var$createReadonlyMethod("add"),
    set: $b4d83761af74a553$var$createReadonlyMethod("set"),
    delete: $b4d83761af74a553$var$createReadonlyMethod("delete"),
    clear: $b4d83761af74a553$var$createReadonlyMethod("clear"),
    forEach: $b4d83761af74a553$var$createForEach(true, true)
};
var $b4d83761af74a553$var$iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
];
$b4d83761af74a553$var$iteratorMethods.forEach((method)=>{
    $b4d83761af74a553$var$mutableInstrumentations[method] = $b4d83761af74a553$var$createIterableMethod(method, false, false);
    $b4d83761af74a553$var$readonlyInstrumentations[method] = $b4d83761af74a553$var$createIterableMethod(method, true, false);
    $b4d83761af74a553$var$shallowInstrumentations[method] = $b4d83761af74a553$var$createIterableMethod(method, false, true);
    $b4d83761af74a553$var$shallowReadonlyInstrumentations[method] = $b4d83761af74a553$var$createIterableMethod(method, true, true);
});
function $b4d83761af74a553$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $b4d83761af74a553$var$shallowReadonlyInstrumentations : $b4d83761af74a553$var$shallowInstrumentations : isReadonly ? $b4d83761af74a553$var$readonlyInstrumentations : $b4d83761af74a553$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($b4d83761af74a553$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $b4d83761af74a553$var$mutableCollectionHandlers = {
    get: $b4d83761af74a553$var$createInstrumentationGetter(false, false)
};
var $b4d83761af74a553$var$shallowCollectionHandlers = {
    get: $b4d83761af74a553$var$createInstrumentationGetter(false, true)
};
var $b4d83761af74a553$var$readonlyCollectionHandlers = {
    get: $b4d83761af74a553$var$createInstrumentationGetter(true, false)
};
var $b4d83761af74a553$var$shallowReadonlyCollectionHandlers = {
    get: $b4d83761af74a553$var$createInstrumentationGetter(true, true)
};
function $b4d83761af74a553$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $b4d83761af74a553$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $b4d83761af74a553$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $b4d83761af74a553$var$reactiveMap = new WeakMap();
var $b4d83761af74a553$var$shallowReactiveMap = new WeakMap();
var $b4d83761af74a553$var$readonlyMap = new WeakMap();
var $b4d83761af74a553$var$shallowReadonlyMap = new WeakMap();
function $b4d83761af74a553$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $b4d83761af74a553$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $b4d83761af74a553$var$targetTypeMap($b4d83761af74a553$var$toRawType(value));
}
function $b4d83761af74a553$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $b4d83761af74a553$var$createReactiveObject(target, false, $b4d83761af74a553$var$mutableHandlers, $b4d83761af74a553$var$mutableCollectionHandlers, $b4d83761af74a553$var$reactiveMap);
}
function $b4d83761af74a553$var$readonly(target) {
    return $b4d83761af74a553$var$createReactiveObject(target, true, $b4d83761af74a553$var$readonlyHandlers, $b4d83761af74a553$var$readonlyCollectionHandlers, $b4d83761af74a553$var$readonlyMap);
}
function $b4d83761af74a553$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$b4d83761af74a553$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $b4d83761af74a553$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $b4d83761af74a553$var$toRaw(observed) {
    return observed && $b4d83761af74a553$var$toRaw(observed["__v_raw"]) || observed;
}
function $b4d83761af74a553$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$b4d83761af74a553$var$magic("nextTick", ()=>$b4d83761af74a553$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$b4d83761af74a553$var$magic("dispatch", (el)=>$b4d83761af74a553$var$dispatch.bind($b4d83761af74a553$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$b4d83761af74a553$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$b4d83761af74a553$var$magic("store", $b4d83761af74a553$var$getStores);
// packages/alpinejs/src/magics/$data.js
$b4d83761af74a553$var$magic("data", (el)=>$b4d83761af74a553$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$b4d83761af74a553$var$magic("root", (el)=>$b4d83761af74a553$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$b4d83761af74a553$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $b4d83761af74a553$var$mergeProxies($b4d83761af74a553$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $b4d83761af74a553$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $b4d83761af74a553$var$globalIdMemo = {};
function $b4d83761af74a553$var$findAndIncrementId(name) {
    if (!$b4d83761af74a553$var$globalIdMemo[name]) $b4d83761af74a553$var$globalIdMemo[name] = 0;
    return ++$b4d83761af74a553$var$globalIdMemo[name];
}
function $b4d83761af74a553$var$closestIdRoot(el, name) {
    return $b4d83761af74a553$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $b4d83761af74a553$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $b4d83761af74a553$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$b4d83761af74a553$var$magic("id", (el)=>(name, key = null)=>{
        let root = $b4d83761af74a553$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $b4d83761af74a553$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$b4d83761af74a553$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$b4d83761af74a553$var$warnMissingPluginMagic("Focus", "focus", "focus");
$b4d83761af74a553$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $b4d83761af74a553$var$warnMissingPluginMagic(name, magicName, slug) {
    $b4d83761af74a553$var$magic(magicName, (el)=>$b4d83761af74a553$var$warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$b4d83761af74a553$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                __placeholder: val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        effect3(()=>innerSet(outerGet()));
        effect3(()=>outerSet(innerGet()));
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$b4d83761af74a553$var$directive("teleport", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $b4d83761af74a553$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = document.querySelector(expression);
    if (!target) $b4d83761af74a553$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $b4d83761af74a553$var$addScopeToNode(clone2, {}, el);
    $b4d83761af74a553$var$mutateDom(()=>{
        target.appendChild(clone2);
        $b4d83761af74a553$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    cleanup2(()=>clone2.remove());
});
// packages/alpinejs/src/directives/x-ignore.js
var $b4d83761af74a553$var$handler = ()=>{};
$b4d83761af74a553$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$b4d83761af74a553$var$directive("ignore", $b4d83761af74a553$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$b4d83761af74a553$var$directive("effect", (el, { expression: expression }, { effect: effect3 })=>effect3($b4d83761af74a553$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $b4d83761af74a553$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler3 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $b4d83761af74a553$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $b4d83761af74a553$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("prevent")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler3 = wrapHandler(handler3, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler3 = wrapHandler(handler3, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler3, options);
    });
    handler3 = wrapHandler(handler3, (next, e)=>{
        if ($b4d83761af74a553$var$isKeyEvent(event)) {
            if ($b4d83761af74a553$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $b4d83761af74a553$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $b4d83761af74a553$var$debounce(handler3, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $b4d83761af74a553$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $b4d83761af74a553$var$throttle(handler3, wait);
    }
    listenerTarget.addEventListener(event, handler3, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler3, options);
    };
}
function $b4d83761af74a553$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $b4d83761af74a553$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b4d83761af74a553$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $b4d83761af74a553$var$kebabCase2(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $b4d83761af74a553$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $b4d83761af74a553$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $b4d83761af74a553$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $b4d83761af74a553$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($b4d83761af74a553$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $b4d83761af74a553$var$keyToModifiers(key) {
    if (!key) return [];
    key = $b4d83761af74a553$var$kebabCase2(key);
    let modifierToKeyMap = {
        ctrl: "control",
        slash: "/",
        space: "-",
        spacebar: "-",
        cmd: "meta",
        esc: "escape",
        up: "arrow-up",
        down: "arrow-down",
        left: "arrow-left",
        right: "arrow-right",
        period: ".",
        equal: "="
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$b4d83761af74a553$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let evaluate2 = $b4d83761af74a553$var$evaluateLater(el, expression);
    let assignmentExpression = `${expression} = rightSideOfExpression($event, ${expression})`;
    let evaluateAssignment = $b4d83761af74a553$var$evaluateLater(el, assignmentExpression);
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let assigmentFunction = $b4d83761af74a553$var$generateAssignmentFunction(el, modifiers, expression);
    let removeListener = $b4d83761af74a553$var$on(el, event, modifiers, (e)=>{
        evaluateAssignment(()=>{}, {
            scope: {
                $event: e,
                rightSideOfExpression: assigmentFunction
            }
        });
    });
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    let evaluateSetModel = $b4d83761af74a553$var$evaluateLater(el, `${expression} = __placeholder`);
    el._x_model = {
        get () {
            let result;
            evaluate2((value)=>result = value);
            return result;
        },
        set (value) {
            evaluateSetModel(()=>{}, {
                scope: {
                    __placeholder: value
                }
            });
        }
    };
    el._x_forceModelUpdate = ()=>{
        evaluate2((value)=>{
            if (value === void 0 && expression.match(/\./)) value = "";
            window.fromModel = true;
            $b4d83761af74a553$var$mutateDom(()=>$b4d83761af74a553$var$bind(el, "value", value));
            delete window.fromModel;
        });
    };
    effect3(()=>{
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate();
    });
});
function $b4d83761af74a553$var$generateAssignmentFunction(el, modifiers, expression) {
    if (el.type === "radio") $b4d83761af74a553$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    return (event, currentValue)=>{
        return $b4d83761af74a553$var$mutateDom(()=>{
            if (event instanceof CustomEvent && event.detail !== void 0) return event.detail || event.target.value;
            else if (el.type === "checkbox") {
                if (Array.isArray(currentValue)) {
                    let newValue = modifiers.includes("number") ? $b4d83761af74a553$var$safeParseNumber(event.target.value) : event.target.value;
                    return event.target.checked ? currentValue.concat([
                        newValue
                    ]) : currentValue.filter((el2)=>!$b4d83761af74a553$var$checkedAttrLooseCompare2(el2, newValue));
                } else return event.target.checked;
            } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $b4d83761af74a553$var$safeParseNumber(rawValue);
            }) : Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
            else {
                let rawValue = event.target.value;
                return modifiers.includes("number") ? $b4d83761af74a553$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
            }
        });
    };
}
function $b4d83761af74a553$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $b4d83761af74a553$var$isNumeric2(number) ? number : rawValue;
}
function $b4d83761af74a553$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $b4d83761af74a553$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-cloak.js
$b4d83761af74a553$var$directive("cloak", (el)=>queueMicrotask(()=>$b4d83761af74a553$var$mutateDom(()=>el.removeAttribute($b4d83761af74a553$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$b4d83761af74a553$var$addInitSelector(()=>`[${$b4d83761af74a553$var$prefix("init")}]`);
$b4d83761af74a553$var$directive("init", $b4d83761af74a553$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$b4d83761af74a553$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b4d83761af74a553$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$b4d83761af74a553$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b4d83761af74a553$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $b4d83761af74a553$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$b4d83761af74a553$var$mapAttributes($b4d83761af74a553$var$startingWith(":", $b4d83761af74a553$var$into($b4d83761af74a553$var$prefix("bind:"))));
$b4d83761af74a553$var$directive("bind", (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $b4d83761af74a553$var$injectBindingProviders(bindingProviders);
        let getBindings = $b4d83761af74a553$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $b4d83761af74a553$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $b4d83761af74a553$var$storeKeyForXFor(el, expression);
    let evaluate2 = $b4d83761af74a553$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $b4d83761af74a553$var$mutateDom(()=>$b4d83761af74a553$var$bind(el, value, result, modifiers));
        }));
});
function $b4d83761af74a553$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$b4d83761af74a553$var$addRootSelector(()=>`[${$b4d83761af74a553$var$prefix("data")}]`);
$b4d83761af74a553$var$directive("data", $b4d83761af74a553$var$skipDuringClone((el, { expression: expression }, { cleanup: cleanup2 })=>{
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $b4d83761af74a553$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $b4d83761af74a553$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $b4d83761af74a553$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0) data2 = {};
    $b4d83761af74a553$var$injectMagics(data2, el);
    let reactiveData = $b4d83761af74a553$var$reactive(data2);
    $b4d83761af74a553$var$initInterceptors(reactiveData);
    let undo = $b4d83761af74a553$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $b4d83761af74a553$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $b4d83761af74a553$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
}));
// packages/alpinejs/src/directives/x-show.js
$b4d83761af74a553$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $b4d83761af74a553$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $b4d83761af74a553$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $b4d83761af74a553$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $b4d83761af74a553$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$b4d83761af74a553$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $b4d83761af74a553$var$parseForExpression(expression);
    let evaluateItems = $b4d83761af74a553$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $b4d83761af74a553$var$evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$b4d83761af74a553$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $b4d83761af74a553$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($b4d83761af74a553$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $b4d83761af74a553$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $b4d83761af74a553$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($b4d83761af74a553$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $b4d83761af74a553$var$mutateDom(()=>{
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            $b4d83761af74a553$var$refreshScope(elForSpot, scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            $b4d83761af74a553$var$addScopeToNode(clone2, $b4d83761af74a553$var$reactive(scope2), templateEl);
            $b4d83761af74a553$var$mutateDom(()=>{
                lastEl.after(clone2);
                $b4d83761af74a553$var$initTree(clone2);
            });
            if (typeof key === "object") $b4d83761af74a553$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)$b4d83761af74a553$var$refreshScope(lookup[sames[i]], scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $b4d83761af74a553$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $b4d83761af74a553$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $b4d83761af74a553$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $b4d83761af74a553$var$handler2() {}
$b4d83761af74a553$var$handler2.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $b4d83761af74a553$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$b4d83761af74a553$var$directive("ref", $b4d83761af74a553$var$handler2);
// packages/alpinejs/src/directives/x-if.js
$b4d83761af74a553$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let evaluate2 = $b4d83761af74a553$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $b4d83761af74a553$var$addScopeToNode(clone2, {}, el);
        $b4d83761af74a553$var$mutateDom(()=>{
            el.after(clone2);
            $b4d83761af74a553$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $b4d83761af74a553$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($b4d83761af74a553$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$b4d83761af74a553$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$b4d83761af74a553$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$b4d83761af74a553$var$mapAttributes($b4d83761af74a553$var$startingWith("@", $b4d83761af74a553$var$into($b4d83761af74a553$var$prefix("on:"))));
$b4d83761af74a553$var$directive("on", $b4d83761af74a553$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $b4d83761af74a553$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $b4d83761af74a553$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                $event: e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$b4d83761af74a553$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$b4d83761af74a553$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$b4d83761af74a553$var$warnMissingPluginDirective("Focus", "trap", "focus");
$b4d83761af74a553$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $b4d83761af74a553$var$warnMissingPluginDirective(name, directiveName2, slug) {
    $b4d83761af74a553$var$directive(directiveName2, (el)=>$b4d83761af74a553$var$warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$b4d83761af74a553$var$alpine_default.setEvaluator($b4d83761af74a553$var$normalEvaluator);
$b4d83761af74a553$var$alpine_default.setReactivityEngine({
    reactive: $b4d83761af74a553$var$reactive2,
    effect: $b4d83761af74a553$var$effect2,
    release: $b4d83761af74a553$var$stop,
    raw: $b4d83761af74a553$var$toRaw
});
var $b4d83761af74a553$var$src_default = $b4d83761af74a553$var$alpine_default;
// packages/alpinejs/builds/module.js
var $b4d83761af74a553$export$2e2bcd8739ae039 = $b4d83761af74a553$var$src_default;


// packages/intersect/src/index.js
function $b41a9b07076d6616$var$src_default(Alpine) {
    Alpine.directive("intersect", (el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $b41a9b07076d6616$var$getRootMargin(modifiers),
            threshold: $b41a9b07076d6616$var$getThreshhold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    });
}
function $b41a9b07076d6616$var$getThreshhold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $b41a9b07076d6616$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $b41a9b07076d6616$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($b41a9b07076d6616$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $b41a9b07076d6616$export$2e2bcd8739ae039 = $b41a9b07076d6616$var$src_default;


var $c25862d578302e4a$exports = {};
(function(global, factory) {
    factory();
})($c25862d578302e4a$exports, function() {
    'use strict';
    /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */ function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            'datetime-local': true
        };
        /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */ function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) return true;
            return false;
        }
        /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */ function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) return true;
            if (tagName === 'TEXTAREA' && !el.readOnly) return true;
            if (el.isContentEditable) return true;
            return false;
        }
        /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */ function addFocusVisibleClass(el) {
            if (el.classList.contains('focus-visible')) return;
            el.classList.add('focus-visible');
            el.setAttribute('data-focus-visible-added', '');
        }
        /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */ function removeFocusVisibleClass(el) {
            if (!el.hasAttribute('data-focus-visible-added')) return;
            el.classList.remove('focus-visible');
            el.removeAttribute('data-focus-visible-added');
        }
        /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */ function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) return;
            if (isValidFocusTarget(scope.activeElement)) addFocusVisibleClass(scope.activeElement);
            hadKeyboardEvent = true;
        }
        /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */ function onPointerDown(e) {
            hadKeyboardEvent = false;
        }
        /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */ function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) return;
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) addFocusVisibleClass(e.target);
        }
        /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */ function onBlur(e) {
            if (!isValidFocusTarget(e.target)) return;
            if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                }, 100);
                removeFocusVisibleClass(e.target);
            }
        }
        /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */ function onVisibilityChange(e) {
            if (document.visibilityState === 'hidden') {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) hadKeyboardEvent = true;
                addInitialPointerMoveListeners();
            }
        }
        /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */ function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }
        /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */ function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') return;
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }
        // For some kinds of state, we are interested in changes at the global scope
        // only. For example, global pointer input, global key presses and global
        // visibility change should affect the state at every scope:
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();
        // For focus and blur, we specifically care about state changes in the local
        // scope. This is because focus / blur events that originate from within a
        // shadow root are not re-dispatched from the host element if it was already
        // the active element in its own scope:
        scope.addEventListener('focus', onFocus, true);
        scope.addEventListener('blur', onBlur, true);
        // We detect that a node is a ShadowRoot by ensuring that it is a
        // DocumentFragment and also has a host property. This check covers native
        // implementation and polyfill implementation transparently. If we only cared
        // about the native implementation, we could just check if the scope was
        // an instance of a ShadowRoot.
        if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
        else if (scope.nodeType === Node.DOCUMENT_NODE) {
            document.documentElement.classList.add('js-focus-visible');
            document.documentElement.setAttribute('data-js-focus-visible', '');
        }
    }
    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        // Make the polyfill helper globally available. This can be used as a signal
        // to interested libraries that wish to coordinate with the polyfill for e.g.,
        // applying the polyfill to a shadow root:
        window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
        // Notify interested libraries of the polyfill's presence, in case the
        // polyfill was loaded lazily:
        var event;
        try {
            event = new CustomEvent('focus-visible-polyfill-ready');
        } catch (error) {
            // IE11 does not support using CustomEvent as a constructor directly:
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
        }
        window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
});


parcelRequire("k2fvL");
(0, $b4d83761af74a553$export$2e2bcd8739ae039).plugin((0, $b41a9b07076d6616$export$2e2bcd8739ae039));
(0, $b4d83761af74a553$export$2e2bcd8739ae039).start();


//# sourceMappingURL=home.ad9c0fcc.js.map
